import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import MyDatePicker from "../../components/MyDatePicker";
import dayjs from "dayjs";

const initialItinerary = {
  from_date: null,
  to_date: null,
  days: 1,
  travel_description: "",
  hotel_name: "",
  hotel_address: "",
  hotel_phone: "",
};

export default function ItinerarySubform({
  itineraries = [],
  onAdd,
  onEdit,
  onDelete,
}) {
  const [draft, setDraft] = useState(initialItinerary);
  const [editIndex, setEditIndex] = useState(-1);

  useEffect(() => {
    if (editIndex >= 0) {
      setDraft(itineraries[editIndex]);
    } else {
      setDraft(initialItinerary);
    }
  }, [editIndex, itineraries]);

  function handleChange(e) {
    const { name, value } = e.target;
    setDraft((d) => ({ ...d, [name]: value }));
  }

  // function handleDateChange(name, date) {
  //   if (date && !isNaN(date)) {
  //     const isoDate = date.toISOString();
  //     setDraft((d) => ({ ...d, [name]: isoDate }));
  //   } else {
  //     setDraft((d) => ({ ...d, [name]: null }));
  //   }
  // }

  function validate() {
    if (!draft.from_date || !draft.to_date) return false;
    return true;
  }

  function onAddOrUpdate() {
    if (!validate()) {
      alert("Please select From and To dates.");
      return;
    }
    if (editIndex === -1) {
      onAdd(draft);
    } else {
      onEdit(editIndex, draft);
    }
    setDraft(initialItinerary);
    setEditIndex(-1);
  }

  function onCancel() {
    setDraft(initialItinerary);
    setEditIndex(-1);
  }

  function formatDate(d) {
    if (!d) return "";
    return dayjs(d).format("DD/MM/YYYY");
  }


function handleDateChange(name, date) {
  if (date && !isNaN(date)) {
    const isoDate = date.toISOString();
    setDraft((prev) => {
      const newDraft = { ...prev, [name]: isoDate };

      // Compute days if both dates are available
      if (newDraft.from_date && newDraft.to_date) {
        const fromDate = dayjs(newDraft.from_date);
        const toDate = dayjs(newDraft.to_date);

        // days difference + 1
        const dayCount = toDate.diff(fromDate, "day") + 1;
        newDraft.days = dayCount > 0 ? dayCount : 1; // minimum 1 day
      }
      return newDraft;
    });
  } else {
    setDraft((prev) => ({ ...prev, [name]: null, days: 1 }));
  }
}



  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: "bold", mb:1 }}>
        Itineraries
      </Typography>

      {/* Form inputs in flex wrap */}
      <Box display="flex" flexWrap="wrap" gap={2} mb={1}>
        <MyDatePicker
          label="From Date"
          value={draft.from_date ? new Date(draft.from_date) : null}
          onChange={(date) => handleDateChange("from_date", date)}
        />
        <MyDatePicker
          label="To Date"
          value={draft.to_date ? new Date(draft.to_date) : null}
          onChange={(date) => handleDateChange("to_date", date)}
        />
        <TextField
          name="days"
          label="Days"
          type="number"
          size="small"
          value={draft.days}
          onChange={handleChange}
          sx={{ width: 80 }}
          inputProps={{ min: 1 }}
        />
        <TextField
          name="travel_description"
          label="Description"
          size="small"
          value={draft.travel_description}
          onChange={handleChange}
          sx={{ minWidth: 200, flexGrow: 1 }}
        />
        </Box>

      <Box display="flex" flexWrap="wrap" gap={2} mb={1}>
        <TextField
          name="hotel_name"
          label="Hotel Name"
          size="small"
          value={draft.hotel_name}
          onChange={handleChange}
          sx={{ minWidth: 380 }}
        />
        <TextField
          name="hotel_address"
          label="Hotel Address"
          size="small"
          value={draft.hotel_address}
          onChange={handleChange}
          sx={{ minWidth: 555 }}
        />
        <TextField
          name="hotel_phone"
          label="Hotel Phone"
          size="small"
          value={draft.hotel_phone}
          onChange={handleChange}
          sx={{ minWidth: 100 }}
        />
        <Button variant="contained" size="small" onClick={onAddOrUpdate}>
          {editIndex === -1 ? "Add" : "Update"}
        </Button>
        {editIndex !== -1 && (
          <Button variant="outlined" size="small" onClick={onCancel}>
            Cancel
          </Button>
        )}
      </Box>

      {/* Table for itineraries */}
      {itineraries.length === 0 ? (
        <Typography>No itineraries added</Typography>
      ) : (
 <TableContainer component={Paper} sx={{ maxHeight: 400, mt: 2 }}>
  {itineraries.length === 0 ? (
    <Typography sx={{ p: 2 }}>No itineraries added</Typography>
  ) : (
    <Table
      size="small"
      sx={{
        border: "1px solid #ccc",
        tableLayout: "fixed",
        width: "100%",
      }}
    >
      <TableHead>
        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
          <TableCell
            sx={{
              border: "1px solid #ccc",
              width: 120,
              fontSize: "0.80rem",
              fontWeight: "bold",
            }}
          >
            From Date
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #ccc",
              width: 120,
              fontSize: "0.80rem",
              fontWeight: "bold",
            }}
          >
            To Date
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #ccc",
              width: 40,
              fontSize: "0.80rem",
              fontWeight: "bold",
            }}
          >
            Days
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #ccc",
              minWidth: 180,
              fontSize: "0.80rem",
              fontWeight: "bold",
            }}
          >
            Description
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #ccc",
              minWidth: 140,
              fontSize: "0.80rem",
              fontWeight: "bold",
            }}
          >
            Hotel Name
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #ccc",
              minWidth: 140,
              fontSize: "0.80rem",
              fontWeight: "bold",
            }}
          >
            Hotel Address
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #ccc",
              minWidth: 120,
              fontSize: "0.80rem",
              fontWeight: "bold",
            }}
          >
            Hotel Phone
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #ccc",
              fontSize: "0.80rem",
              width: 80,
            }}
            align="center"
          >
            Actions
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {itineraries.map((it, i) => (
          <TableRow key={i}>
            <TableCell
              sx={{
                border: "1px solid #ccc",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontSize: "0.80rem",
              }}
            >
              {formatDate(it.from_date)}
            </TableCell>
            <TableCell
              sx={{
                border: "1px solid #ccc",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontSize: "0.80rem",
              }}
            >
              {formatDate(it.to_date)}
            </TableCell>
            <TableCell
              sx={{
                border: "1px solid #ccc",
                fontSize: "0.80rem",
                textAlign: "center",
              }}
            >
              {it.days}
            </TableCell>
            <TableCell
              sx={{
                border: "1px solid #ccc",
                maxWidth: 250,
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontSize: "0.80rem",
              }}
            >
              {it.travel_description}
            </TableCell>
            <TableCell
              sx={{
                border: "1px solid #ccc",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontSize: "0.80rem",
              }}
            >
              {it.hotel_name}
            </TableCell>
            <TableCell
              sx={{
                border: "1px solid #ccc",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontSize: "0.80rem",
              }}
            >
              {it.hotel_address}
            </TableCell>
            <TableCell
              sx={{
                border: "1px solid #ccc",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontSize: "0.80rem",
              }}
            >
              {it.hotel_phone}
            </TableCell>
            <TableCell
              sx={{ border: "1px solid #ccc", fontSize: "0.80rem" }}
              align="center"
            >
              <IconButton size="small" onClick={() => setEditIndex(i)}>
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" onClick={() => onDelete(i)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )}
</TableContainer>


      )}
    </Box>
  );
}
